import { Box, Flex, Text, Button, Heading, Card, Container } from '@radix-ui/themes';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicyPage = () => {
    const navigate = useNavigate();

    return (
        <Flex
            direction="column"
            align="center"
            gap="9"
            py="9"
            px="4"
            style={{ minHeight: '100vh' }}
        >
            {/* Header Section */}
            <Container size="4">
                <Flex direction="column" gap="4" maxWidth="1080px">
                    <Text size="9" weight="bold" align="center">
                        Privacy Policy
                    </Text>
                    <Text size="4" color="gray" align="center">
                        Last Updated: March 13, 2025
                    </Text>
                </Flex>
            </Container>

            {/* Content Section */}
            <Container size="3">
                <Flex direction="column" gap="6" width="100%" maxWidth="800px">
                    <Box>
                        <Heading size="5">1. Introduction</Heading>
                        <Text size="3">
                            Welcome to Dext Technology. We are committed to protecting your personal information and your right to privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our adaptive learning platform.
                        </Text>
                    </Box>

                    <Box>
                        <Heading size="5">2. Information We Collect</Heading>
                        <Text size="3">
                            We collect personal information that you provide to us, such as your name, email address, and payment information when you register or use our services. We also collect usage data (e.g., quiz responses, progress tracking) to personalize your learning experience.
                        </Text>
                    </Box>

                    <Box>
                        <Heading size="5">3. How We Use Your Information</Heading>
                        <Text size="3">
                            We use your information to provide and improve our services, process payments, communicate with you, and offer personalized learning insights. We may also use aggregated data for analytics purposes.
                        </Text>
                    </Box>

                    <Box>
                        <Heading size="5">4. Sharing Your Information</Heading>
                        <Text size="3">
                            We do not sell your personal information. We may share it with trusted third-party service providers (e.g., payment processors, hosting services) to operate our platform, but only under strict confidentiality agreements.
                        </Text>
                    </Box>

                    <Box>
                        <Heading size="5">5. Your Rights</Heading>
                        <Text size="3">
                            You have the right to access, update, or delete your personal information. Contact us at info@thesciencenet.com to exercise these rights or for any privacy-related questions.
                        </Text>
                    </Box>

                    <Box>
                        <Heading size="5">6. Security</Heading>
                        <Text size="3">
                            We implement reasonable security measures to protect your data, but no system is completely secure. We strive to safeguard your information against unauthorized access or disclosure.
                        </Text>
                    </Box>

                    <Box>
                        <Heading size="5">7. Changes to This Policy</Heading>
                        <Text size="3">
                            We may update this Privacy Policy from time to time. Changes will be posted here, and significant updates will be communicated via email or through our platform.
                        </Text>
                    </Box>

                    <Box>
                        <Heading size="5">8. Contact Us</Heading>
                        <Text size="3">
                            If you have questions about this Privacy Policy, reach out to us at info@thesciencenet.com or Dext Technology, Kumasi, Ghana.
                        </Text>
                    </Box>
                </Flex>
            </Container>
        </Flex>
    );
};

export default PrivacyPolicyPage;